import yup from '../../../config/yup';

export const s3ReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('s3Reader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  connectionKey: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    s3BucketName: yup.string().transform((value) => value.trim()),
    s3ObjectKey: yup.string().transform((value) => value.trim()),
    awsKey: yup.string().transform((value) => value.trim()),
    awsSecretKey: yup.string().transform((value) => value.trim()),
  }),
});
